module.exports = __webpack_public_path__ + "static/img/operate.e0912bd7.png";